import * as React from "react"
import { connect } from "react-redux"
import { ConnectedRouter } from "react-router-redux"
import { IntlProvider } from "react-intl"
import { library } from "@fortawesome/fontawesome-svg-core"
import { fab } from "@fortawesome/free-brands-svg-icons"
import { far } from "@fortawesome/free-regular-svg-icons"
import { fas } from "@fortawesome/free-solid-svg-icons"
import classnames from "classnames"
import { checkIsMobileDevice } from "./helpers/utility"
import "./index.css"
import AppRedux from "./redux/app/appRedux"
import AppLocale from "./languageProvider"
import AppConfig from "./configs/AppConfig"
import AppRouter from "./containers/App/AppRouter"
import Navigation from "./components/navigation/navigation"
import Footer from "./components/footer/footer"
import ScrollToTop from "./scrollToTop"

class MainRouter extends React.Component<
  {
    history: any
    isLoggedIn: boolean
    startup: () => void
    bookingResponse: number
  },
  {
    startupComplete: boolean
    language: any
    navHeight: number
  }
> {
  public constructor(props) {
    super(props)
    this.state = {
      startupComplete: false,
      language: null,
      navHeight: 80
    }
  }

  public componentDidMount() {
    this.props.startup()
  }

  public componentWillReceiveProps(newProps) {
    const newState = {
      startupComplete: newProps.startupComplete,
      language:
        newProps.language === "th" || newProps.language === "en"
          ? newProps.language
          : AppConfig.defaultLanguage
    }
    this.setState(newState)
  }

  public render() {
    library.add(fab, far, fas)
    const loadComplete = this.state.startupComplete
    const locale =
      this.state.language === "th" || this.state.language === "en"
        ? this.state.language
        : AppConfig.defaultLanguage

    const currentAppLocale = AppLocale[locale]
    const { navHeight } = this.state
    return (
      <ConnectedRouter history={this.props.history}>
        {loadComplete ? (
          <IntlProvider locale={locale} messages={currentAppLocale.messages}>
            <React.Fragment>
              <Navigation locale={locale} navHieght={navHeight} />
              <ScrollToTop language={locale}>
                <div
                  style={{ minHeight: 550 }}
                  id="mainContainer"
                  className={classnames({
                   
                  })}
                >
                  <AppRouter />
                </div>
              </ScrollToTop>
              <Footer language={locale} />
            </React.Fragment>
          </IntlProvider>
        ) : null}
      </ConnectedRouter>
    )
  }
}

const mapStateToProps = state => {
  return {
    startupComplete: state.Volatile ? state.Volatile.startupComplete : false,
    language: state.Language ? state.Language.language : "th",
    router: state.router
  }
}

const mapDispatchToProps = dispatch => {
  return {
    startup: () => dispatch(AppRedux.startup())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainRouter)



// WEBPACK FOOTER //
// ./src/router.tsx